/** CONSTANTS */

const LF_KEYS = {
  PERSONS: 'persons'
};

export { LF_KEYS };